import gql from 'graphql-tag';
import LeadFragments from '../fragments/lead.fragments';

const REQUEST_LEAD_FILE_ACCESS_LEVEL = gql`
  mutation requestLeadFileAccessLevel($params: RequestLeadFileAccessLevelParams!) {
    requestLeadFileAccessLevel(params: $params) {
      ...LeadFields
      ...LeadLoiFiles
      ...LeadOffers
      ...LeadFileAccessLevel
      ...LeadNotes
      ...LeadSellerNotes
      ...LeadUser
      ...LeadListing
      ...LeadMetrics
      ...LeadMeta
      ...LeadAnalyticsEvents
      ...LeadChannel
    }
  }

  ${LeadFragments.fields}
  ${LeadFragments.loiFiles}
  ${LeadFragments.offers}
  ${LeadFragments.fileAccessLevel}
  ${LeadFragments.notes}
  ${LeadFragments.sellerNotes}
  ${LeadFragments.user}
  ${LeadFragments.listing}
  ${LeadFragments.metrics}
  ${LeadFragments.meta}
  ${LeadFragments.analyticsEvents}
  ${LeadFragments.channel}
`;

export default REQUEST_LEAD_FILE_ACCESS_LEVEL;
